import WarningIcon from "@material-ui/icons/ErrorRounded"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { Tooltip } from "@material-ui/core"

type Props = {
  error: string
}

export function CellError({ error }: Props) {
  const { t } = useI18n()

  return (
    <Tooltip title={t(error)} placement="bottom-start" className={errorCn}>
      <WarningIcon color="inherit" />
    </Tooltip>
  )
}

const errorCn = css`
  position: absolute;
  left: 0;
  top: 0;
  color: var(--red);
`
